import { createContext, Dispatch, SetStateAction } from "react";
import { CollaboratorType, UsersLocation } from "../../types/Multiplayer.types";

type CollaboratorsContextType = {
  activeCollaborators: CollaboratorType[];
  setActiveCollaborators: Dispatch<SetStateAction<CollaboratorType[]>>;
  addOrUpdateCollaborator: (usersLocation: UsersLocation[]) => void;
};

export const CollaboratorsContext = createContext<CollaboratorsContextType>({
  activeCollaborators: [],
  setActiveCollaborators: () => {},
  addOrUpdateCollaborator: () => {},
});
